import React from 'react';
import RenewalSuccessOld from './OldDesigns';

function Index() {
	return <RenewalSuccessOld />;
}

export default Index;
